export default __webpack_public_path__ + "static/media/box.892bd595.png";